export var pastIntractionDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                Id: item.id,
                BucketId: item.bucketId,
                BucketName: item.bucketName,
                AcCode: item.acCode,
                AcName: item.acName,
                TypeOfContact: item.typeOfContact,
                TaskDescription: item.taskDescription,
                Priority: item.priority,
                StatusId: item.statusId,
                StatusName: item.statusName,
                Source: item.source,
                DueDate: item.dueDate,
                CreatedDate: item.createdDate,
                ResponseId: item.responseId,
                Response: item.response,
                CloseDate: item.closeDate,
                CategoryId: item.categoryId,
                CategoryName: item.categoryName,
                SubCategoryId: item.subCategoryId,
                SubCategoryName: item.subCategoryName,
                ProductId: item.productId,
                ProductName: item.productName,
                DealerEmpCode: item.dealerEmpCode,
                Notes: item.notes,
                IsClientContacted: item.isClientContacted,
                MeetingClosureDate: item.meetingClosureDate,
                AssignedToName: item.assignedToName,
            };
        });
    }
    return result;
};
